import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import Layout from "../components/Layout";
import Breadcrumbs from "../components/Breadcrumbs";
import PreFooterCTA from "../components/PreFooterCTA";
import { PORTFOLIO } from "../data/business";

const BREADCRUMBS = [{ label: "Gallery" }];
const CATEGORIES = ["All", ...Array.from(new Set(PORTFOLIO.map((p) => p.category)))];

export default function Gallery() {
  const [filter, setFilter] = useState("All");
  const items = filter === "All" ? PORTFOLIO : PORTFOLIO.filter((p) => p.category === filter);
  return (
    <Layout>
      <section className="bg-[#1A1D21] text-white">
        <div className="abc-container py-12 md:py-16">
          <Breadcrumbs items={BREADCRUMBS} />
          <h1 className="font-display mt-4 text-4xl sm:text-5xl font-extrabold">Recent <span className="text-[#E31D2B]">drain &amp; sewer projects</span></h1>
          <p className="mt-4 text-white/80 max-w-2xl text-lg">Real homes, real jobs, clean finish. A small sample of recent drain &amp; sewer work across the Baltimore and Temple Hills / DC metros.</p>
        </div>
      </section>

      <section className="py-10 md:py-14 abc-bg-pale">
        <div className="abc-container">
          <div className="flex flex-wrap gap-2" data-testid="gallery-filters">
            {CATEGORIES.map((c) => (
              <button key={c} onClick={() => setFilter(c)} data-testid={`gallery-filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition ${filter === c ? "bg-[#1A1D21] text-white" : "bg-[#F5F6F8] text-[#1A1D21] hover:bg-[#EDEFF2]"}`}>
                {c}
              </button>
            ))}
          </div>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((p) => (
              <div key={p.title} className="abc-card overflow-hidden group">
                <div className="aspect-[4/3] overflow-hidden bg-[#F5F6F8]">
                  <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                </div>
                <div className="p-5">
                  <div className="text-xs font-semibold text-[#54616E] uppercase tracking-wider">{p.category}</div>
                  <h3 className="font-display font-bold text-[#1A1D21] mt-1">{p.title}</h3>
                  <p className="text-sm text-slate-500 mt-1">{p.city}</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-[#1A1D21]">Before · After <ArrowRight className="w-4 h-4 text-[#54616E]" /></span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PreFooterCTA />
    </Layout>
  );
}
